<app-rich-text
    class="vehicle-variants-leasing-spot__text"
    *ngIf="data?.spotText"
    [html]="data?.spotText"
></app-rich-text>

<ul class="vehicle-variants-leasing-spot__list" *ngIf="variants.length">
    <li
        class="vehicle-variants-leasing-spot__item"
        *ngFor="let variant of variants"
    >
        <div
            class="campaign-tag leasing-item__banner"
            *ngIf="variant.isPopularChoice"
            [innerText]="'generic.popular_badge_text' | translate"
        ></div>

        <div class="leasing-item__image">
            <img
                loading="lazy"
                [src]="variant.image?.src | resolveMediaUrl: { format: 'webp', width: 400 }"
                appImageLoadFadeIn
            />
        </div>

        <div class="leasing-item__info">
            <div
                class="component-header--small theme-text"
                [innerText]="'leasing.leasing_offer_text' | translate"
            ></div>

            <div class="leasing-item__price">
                {{ variant.leasingPricePerMonth | defaultcurrency }}/{{
                    'generic.month_abbreviation' | translate
                }}
            </div>

            <div class="leasing-item__name">
                {{ variant.modelName }} {{ variant.variantName }}
            </div>
        </div>

        <!-- Accessories -->
        <div
            class="vehicle-variants-leasing-spot__accessories"
            *ngIf="variant.accessoriesList"
        >
            <app-vehicle-accessories-list
                class="vehicle-variants-leasing-spot__accessories-list"
                [listHeaderText]="
                    'new_vehicles.vehicle_accessories_list_header' | translate
                "
                [listItems]="variant.accessoriesList"
                [amountToShow]="6"
                [showAllButton]="true"
            ></app-vehicle-accessories-list>
        </div>

        <div class="vehicle-variants-leasing-spot__details">
            <h3
                class="component-header--small"
                [innerText]="'generic.details_text' | translate"
            ></h3>

            <div class="unstyled-table align-last-cell" role="table">
                <div class="unstyled-table__row" role="row">
                    <div
                        class="
                            unstyled-table__cell unstyled-table__cell--header
                        "
                        role="columnheader"
                        [innerText]="
                            'leasing.leasing_details_deposit_text' | translate
                        "
                    ></div>

                    <div
                        class="
                            unstyled-table__cell unstyled-table__cell--header
                        "
                        role="columnheader"
                        [innerText]="variant.leasingDeposit | defaultcurrency"
                    ></div>
                </div>
                <div class="unstyled-table__row" role="row">
                    <div
                        class="unstyled-table__cell"
                        role="cell"
                        [innerText]="
                            'leasing.leasing_details_km_per_year_text'
                                | translate
                        "
                    ></div>

                    <div class="unstyled-table__cell" role="cell">
                        {{ variant.kilometersPerYear | number }} km
                    </div>
                </div>
                <div class="unstyled-table__row" role="row">
                    <div
                        class="unstyled-table__cell"
                        role="cell"
                        [innerText]="
                            'leasing.leasing_details_maturity_text' | translate
                        "
                    ></div>

                    <div class="unstyled-table__cell" role="cell">
                        {{ variant.loanMaturity }} mdr.
                    </div>
                </div>
            </div>
        </div>

        <div class="vehicle-variants-leasing-spot__actions">
            <app-link
                *ngIf="
                    variant.leasingDetailsLink &&
                    variant.leasingDetailsLink?.url
                "
                [link]="variant.leasingDetailsLink"
                [linkText]="'leasing.leasing_details_button_text' | translate"
                [classString]="
                    'button--primary button--themed leasing-actions-button'
                "
            ></app-link>

            <app-link
                *ngIf="
                    variant.leasingDetailsSecondaryLink &&
                    variant.leasingDetailsSecondaryLink?.url
                "
                [link]="variant.leasingDetailsSecondaryLink"
                [classString]="
                    'button--tertiary button--themed leasing-actions-button'
                "
            ></app-link>
        </div>

        <div class="vehicle-variants-leasing-spot__details-secondary">
            <p *ngIf="variant.leasingOfferTotalPrice">
                {{ 'leasing.leasing_offer_total_price_text' | translate }}
                {{ variant.leasingOfferTotalPrice | defaultcurrency }}
            </p>

            <p *ngIf="variant.leasingValidUntil">
                {{ 'leasing.leasing_offer_date_validity_text' | translate }}
                {{ variant.leasingValidUntil | date: 'dd/MM yyyy' }}
            </p>
        </div>
    </li>
</ul>
